import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const HomeIntroSection = () => {
  const { t } = useTranslation();

  return (
    <section id="intro-section" className="intro-section">
      <div className="intro-container">
        <h1>
          <span>{t("home.intro_section.title_1")}</span>
          <span>{t("home.intro_section.title_2")}</span>
        </h1>
        <p>{t("home.intro_section.text_1")}</p>
        <p>{t("home.intro_section.text_2")}</p>
        <p>{t("home.intro_section.text_3")}</p>
        <div style={{ textAlign: "center" }}>
          <Link to="/contact" className="link-button">
            {t("shared.contact_us")}
          </Link>
        </div>
      </div>
    </section>
  );
};
